export default __webpack_public_path__ + "static/media/6.1d9d7578.png";